<div class="row d-flex">

  <div class="col-8">
    <mat-card class="p-2" appearance="outlined">
      <mat-card-header>
        <mat-card-title>Frequenza</mat-card-title>
      </mat-card-header>

      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div formArrayName="groups" *ngFor="let group of groups.controls; let i = index">
          <div [formGroupName]="i">

            <mat-card-content>

              <div class="row d-flex">


                <div class="col">
                  <mat-form-field>
                    <mat-label>Data inizio e fine</mat-label>
                    <mat-date-range-input [rangePicker]="dataIniziofine">
                      <input matStartDate placeholder="Data inizio" (dateInput)="addEvent('input', $event)"
                        formControlName="datainizio">
                      <input matEndDate placeholder="Data fine" (dateInput)="addEvent2('input', $event)"
                        formControlName="datafine">
                    </mat-date-range-input>
                    <mat-hint>GG/MM/AAAA – GG/MM/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="dataIniziofine"></mat-datepicker-toggle>
                    <mat-date-range-picker #dataIniziofine></mat-date-range-picker>
                  </mat-form-field>
                </div>

                <div class="col">


                  <mat-form-field>
                    <mat-label>Giorni della settimana</mat-label>
                    <mat-select multiple formControlName="giorni">
                      @for (g of giorniLst; track g) {
                      <mat-option [value]="g">{{g}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                </div>


              </div>

              <div class="row d-flex">


                <div class="col">
                  <mat-form-field>
                    <mat-label>Ora inizio</mat-label>
                    <input matInput formControlName="oraInizio" [matTimepicker]="oraInizio">
                    <mat-timepicker-toggle matIconSuffix [for]="oraInizio" />
                    <mat-timepicker #oraInizio />
                  </mat-form-field>
                </div>

                <div class="col">
                  <mat-form-field>
                    <mat-label>Ora fine</mat-label>
                    <input matInput formControlName="oraFine" [matTimepicker]="oraFine">
                    <mat-timepicker-toggle matIconSuffix [for]="oraFine" />
                    <mat-timepicker #oraFine />
                  </mat-form-field>
                </div>






              </div>

              <div class="row d-flex">
                <div class="col">
                  <mat-checkbox formControlName="festivi" class="example-margin">Escludi festivi</mat-checkbox>
                </div>
                <div class="col">
                  <button mat-button type="button" class="mt-2" (click)="removeGroup(i)" *ngIf="i !== 0"> 
                    <mat-icon>delete</mat-icon>Elimina riga
                  </button>

                </div>

              </div>


              <hr>




            </mat-card-content>



          </div>
        </div>

        <mat-card-actions align="end" >
          <button mat-button (click)="addGroup()" type="button">+ Riga</button>

        </mat-card-actions>




        <mat-card-actions align="start">


          <button mat-flat-button type="submit" >
            <mat-icon>arrow_forward</mat-icon>Avanti
          </button>
        </mat-card-actions>



      </form>

    </mat-card>

    <!--<pre>{{ form.value | json }}</pre>
    <pre>{{ valueStrings | json }}</pre>-->
  </div>
  <div class="col-4">

    <mat-card class="p-2" appearance="outlined">
      <mat-card-header>
        <mat-card-title>Riepilogo </mat-card-title>

      </mat-card-header>

      <mat-card-content>
        <div class="row d-flex mt-4">


          <p *ngFor="let value of valueStrings">{{ value }}</p>

        </div>
        <!--<div class="row d-flex mt-4">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>-->
      </mat-card-content>

    </mat-card>

  </div>

</div>